import { render, staticRenderFns } from "./SelfServiceVpAddressChange.vue?vue&type=template&id=7e0a87b8&scoped=true"
import script from "./SelfServiceVpAddressChange.vue?vue&type=script&lang=js"
export * from "./SelfServiceVpAddressChange.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceVpAddressChange.vue?vue&type=style&index=0&id=7e0a87b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0a87b8",
  null
  
)

export default component.exports